// Make sure to only use methods as translations might not be loaded yet when this file is evaluated.
export const translations = {
	sidebar_section_title: () => __("Event Recurrences", null, "Event Recurrence"),
	edit_event_this: (args) => __("This event ({0})", args, "Event Recurrence"),
	edit_event_next: () => __("This event and all following events", null, "Event Recurrence"),
	edit_event_all: () => __("All events", null, "Event Recurrence"),
	edit_event_modal_title: () => __("Edit Recurring Event", null, "Event Recurrence"),
};
